module.exports = __webpack_public_path__ + "img/luna.e05fca3c.svg";